<!-- 个人信息侧边栏 -->
<template>
  <div class="sidecontainer" :class="{ collapsed }">
    <div class="sideManu-name">
      <span class="title-text">个人中心</span>
      <span class="toggle-btn" @click="toggleCollapse">
        <i class="icon iconfont toggle-icon">&#xe702;</i>
      </span>
    </div>
    <ul class="sideManue">
      <li
        v-for="(item,index) in tabList"
        :key="item.key"
        :class="{'active':tabIdx==item.key}"
        @click="goto(item,index)"
      >
        <i class="active_line"></i>
        <span class="icon iconfont" v-html="item.iconleft"></span>
        <div class="menu-label">{{item.label}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'side',

  data () {
    return {
      tabIdx: 'BaseInfo',
      collapsed: localStorage.getItem('mine-side-collapsed') === '1', // 把 collapsed 的初始值直接从 localStorage 读，不再等 mounted,防止组件重建时会先渲染展开态（false），再变成收起态（true），css展开收起动画会闪一下
      tabList: [
        {
          iconleft: '&#xe64d;',
          label: '个人信息',
          router: '/Mine/BaseInfo',
          key: 'BaseInfo'
        },
        {
          iconleft: '&#xe655;',
          label: '实名认证',
          router: '/Mine/RealName',
          key: 'RealName'
        },
        {
          iconleft: '&#xe659;',
          label: '著作权人管理',
          router: '/Mine/Obligee',
          key: 'Obligee'
        },
        // {
        //   iconleft:'&#xe63f;',
        //   label: '账单明细',
        //   router: '/Mine/MoneyBag',
        //   key: 'MoneyBag'
        // },
        // {
        //   iconleft:'&#xe644;',
        //   label: 'VIP权益',
        //   router: '/Mine/Vip',
        //   key: 'MineVip'
        // },
        {
          iconleft: '&#xe64e;',
          label: '我的登记',
          router: '/Mine/MyRegister',
          key: 'MyRegister'
        },
        {
          iconleft: '&#xe64c;',
          label: '我的存证',
          router: '/Mine/ExistingEvidence',
          key: 'MineExistingEvidence'
        },
        {
          iconleft: '&#xe737;',
          label: '我的查重',
          router: '/Mine/MyCheck',
          key: 'MyCheck'
        },
        {
          iconleft: '&#xe605;',
          label: '我的DCI',
          router: '/Mine/MyDCI',
          key: 'MyDCI'
        },
        {
          iconleft: '&#xe67c;',
          label: '我的评价',
          router: '/Mine/MyEvaluate',
          key: 'MyEvaluate'
        },
        // {
        //   iconleft:'&#xe64b;',
        //   label: '我的监测',
        //   router: '/Mine/Monitor',
        //   key: 'MineMonitor'
        // },
        // {
        //   iconleft:'&#xe645;',
        //   label: '我的取证',
        //   router: '/Mine/ObtainEvidence',
        //   key: 'MineObtainEvidence'
        // },
        // {
        //   iconleft:'&#xe638;',
        //   label: '合约管理',
        //   router: '/Mine/OnSale',
        //   key: 'MineOnSale'
        // },
        {
          iconleft: '&#xe64e;',
          label: '证书查询',
          router: '/Mine/MyRegisterStatistics',
          key: 'MyRegisterStatistics'
        },
        {
          iconleft: '&#xe649;',
          label: '消息通知',
          router: '/Mine/Notice',
          key: 'Notice'
        }
      ]
    }
  },

  watch: {
    $route (to) {
      this.tabIdx = to.name
      if (to.name === 'DCIDetail') {
        this.tabIdx = 'MyDCI'
      }
      if (to.name === 'EvaluateDetail') {
        this.tabIdx = 'MyEvaluate'
      }
      // 新增：路由切换时同步收起状态
      this.collapsed = localStorage.getItem('mine-side-collapsed') === '1'
      this.$emit('collapse-change', this.collapsed)
    }
  },

  mounted () {
    this.tabIdx = this.$route.name
    if (this.$route.name === 'DCIDetail') {
      this.tabIdx = 'MyDCI'
    }
    if (this.$route.name === 'EvaluateDetail') {
      this.tabIdx = 'MyEvaluate'
    }
  },

  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
      localStorage.setItem('mine-side-collapsed', this.collapsed ? '1' : '0')
      this.$emit('collapse-change', this.collapsed)
    },

    goto (item) {
      this.$router.push({
        path: item.router,
        query: {}
      })
      this.tabIdx = item.key
      if (item.key === 'DCIDetail') {
        this.tabIdx = 'MyDCI'
      }
      if (item.key === 'EvaluateDetail') {
        this.tabIdx = 'MyEvaluate'
      }
    }
  }
}
</script>

<style lang='scss' scoped>
$side-width: 192px;
$side-collapsed-width: 64px;

.sidecontainer {
  width: $side-width;
  padding-bottom: 16px;
  height: 100%;
  background: #F2F8FF;
  overflow: hidden;
  transition: width .25s ease;
}

.sideManu-name {
  font-size: 18px;
  font-weight: 500;
  height: 88px;
  padding: 0 16px 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;

  .toggle-btn{
    cursor: pointer;
    .toggle-icon {
      font-size: 22px;
      cursor: pointer;
      opacity: 0.8;
      flex-shrink: 0;
      transition: color .2s;
      &:hover {
        color: #007DFF;
      }
    }
  }
}

.sideManue {
  li {
    padding: 14px 0 14px 54px;
    line-height: 20px;
    position: relative;
    white-space: nowrap;
    cursor: pointer;

    .icon {
      font-size: 22px;
      position: absolute;
      left: 24px;
      top: 14px;
      opacity: 0.8;
      transition: left .25s ease;
    }
  }

  li.active,
  li:hover {
    color: #007DFF;
    background: #ffffff;

    .active_line {
      display: block;
      position: absolute;
      left: 0;
      top: 4px;
      width: 2px;
      height: 40px;
      background: #007DFF;
    }
    .icon {
      opacity: 1;
    }
  }
}

/* ============ 收起状态 ============ */
.sidecontainer.collapsed {
  width: $side-collapsed-width;

  .sideManu-name {
    padding: 0;
    justify-content: center;

    .title-text {
      display: none;
    }
  }

  .sideManue li {
    padding-left: 0;
    text-align: center;

    .icon {
      position: static;
      display: inline-block;
      opacity: 0.8;
    }

    .menu-label {
      display: none;
    }

    /* 收起时隐藏左侧高亮竖线，避免和图标冲突 */
    .active_line {
      display: none !important;
    }
  }
}
</style>